import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { Scrollbar } from "../Scrollbar/index.js";
import { ItemsRenderer } from "./ItemsRenderer.js";
import { useItems } from "./hooks/useItems.js";
const noop = () => {
};
function VirtualList(props) {
  const { testId = "virtual-list-root", onSelect, listHeight, RenderItem, selectedItemIds = [] } = props;
  const scrollbarApi = useRef(void 0);
  const { itemsWithPosition, itemsTotalHeight, renderedItems, onScroll } = useItems(props, scrollbarApi);
  return /* @__PURE__ */ jsx("div", { style: { height: listHeight, width: "100%" }, "data-testid": testId, "data-tidal": "VirtualList", children: /* @__PURE__ */ jsx(Scrollbar, { ref: scrollbarApi, onScroll, testId: "virtual-list-scrollbar", children: /* @__PURE__ */ jsx("div", { style: { height: itemsTotalHeight }, children: /* @__PURE__ */ jsx(
    ItemsRenderer,
    {
      RenderItem,
      onSelect: onSelect || noop,
      renderedItems,
      selectedItemIds,
      itemsWithPosition
    }
  ) }) }) });
}
export {
  VirtualList
};
//# sourceMappingURL=VirtualList.js.map
